import axios from 'axios'

export const SystemDataApi = {
    async Bank(type){
        const response = await axios.get('/api/systemdata/banks/'+type)
        return response
    },
    async SMSServices(){
        const response = await axios.get('/api/systemdata/smsservices')
        return response
    },
    async CalculateSHA1(data){
        const response = await axios.post('/api/systemdata/calculate/sha1',data)
        return response
    },
    async CalculateSHA512(data){
        const response = await axios.post('/api/systemdata/calculate/sha512',data)
        return response
    },
    async CalculateSHA1ASCII(data){
        const response = await axios.post('/api/systemdata/calculate/sha1ascii',data)
        return response
    }
}